import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { listDirectory } from "../actions/documentActions";
import {
	setCreatableContext,
	setSubheaderText,
} from "../actions/navigateActions";
import { unselectAll } from "../actions/multiselectActions";

import { encodeFullpath, decodeFullpath } from "../utilities/utilities";

import { AbbreviatedDocumentListDataMessage } from "./Utils/UnderSubHeaderWarningMessages";

import DocumentList from "./DocumentList";
import MaterialTabs from "./MaterialTabs";
import ArchiveAndTrashList from "./ArchiveAndTrashList";

import { withRouter } from "../utilities/withRouter";
import { IconFile, IconArchive, IconTrash } from "@tabler/icons-react";

const basepathnameMap = {
	public: "Public",
	private: "Private",
};

const tabMap = [
	{
		label: (
			<span style={{ display: "flex", alignItems: "center" }}>
				<IconFile style={{ verticalAlign: "sub", marginRight: 8 }} />
				Documents
			</span>
		),
		url: "docs",
	},
	{
		label: (
			<span style={{ display: "flex", alignItems: "center" }}>
				<IconArchive style={{ verticalAlign: "sub" }} />
			</span>
		),
		url: "archive",
		rightJustified: true,
		hoverTitle: "Archive",
	},
	{
		label: (
			<span style={{ display: "flex", alignItems: "center" }}>
				<IconTrash style={{ verticalAlign: "sub" }} />
			</span>
		),
		url: "trash",
		rightJustified: true,
		hoverTitle: "Trash Bin",
	},
];

const DocumentListWithRouter = withRouter(DocumentList);

class FirmDocs extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			s3Basepath: "",
			lastLocation: {
				docs: "",
				archive: "archive/docs",
				trash: "trash/docs",
			},
		};
		this.getUrlPrefix = this.getUrlPrefix.bind(this);
		this.getAPIBasepath = this.getAPIBasepath.bind(this);
		this.switchedTab = this.switchedTab.bind(this);
	}
	getSubheaderText() {
		return (
			basepathnameMap[this.props.match.params.namespace] +
			" Firm Documents"
		);
	}
	isDocTab() {
		return !this.props.match.params.root;
	}
	componentDidMount() {
		if (this.isDocTab()) {
			this.props.listDirectory(
				0,
				this.getAPIBasepath(),
				this.props.match.params.namespace,
				false
			);
			this.props.setCreatableContext(true);
			this.props.unselectAll();
		}
		this.props.setSubheaderText({
			subheaderText: this.getSubheaderText(),
			subheaderIconName: "IconFolderSymlink",
		});
	}
	componentWillUnmount() {
		this.props.setCreatableContext(false);
	}
	componentDidUpdate(prevProps) {
		const { namespace, fullpath, root } = this.props.match.params;
		const prevParams = prevProps.match.params;
		const isDocTab = !root;

		if (
			isDocTab &&
			(prevParams.fullpath !== fullpath ||
				prevParams.namespace !== namespace)
		) {
			setTimeout(() => {
				this.props.listDirectory(
					0,
					this.getAPIBasepath(),
					namespace,
					false
				);
				this.props.unselectAll();
				var table = document.querySelector(".rt-tbody");
				if (table) table.scrollTop = 0;
			}, 0);
		}
		if (prevParams.namespace !== namespace || prevParams.root !== root) {
			this.props.setSubheaderText({
				subheaderText: this.getSubheaderText(),
				subheaderIconName: "IconFolderSymlink",
			});
			this.props.setCreatableContext(isDocTab);
		}
	}
	getUrlPrefix() {
		return "/firmDocs/" + this.props.match.params.namespace + "/docs/";
	}
	getAPIBasepath() {
		const { namespace, fullpath } = this.props.match.params;
		return namespace + "/" + (decodeFullpath(fullpath) || "");
	}
	switchedTab(value) {
		const namespace = this.props.match.params.namespace;
		let suffix;
		if (value === 0) {
			suffix = "docs/" + this.state.lastLocation.docs;
		} else if (value === 1) {
			suffix = this.state.lastLocation.archive;
		} else if (value === 2) {
			suffix = this.state.lastLocation.trash;
		}
		this.props.history.push("/firmDocs/" + namespace + "/" + suffix);
	}
	static getDerivedStateFromProps(props, state) {
		const { root, context, fullpath } = props.match.params;
		var lastLocation = { ...state.lastLocation };
		if (!root) {
			lastLocation.docs = encodeFullpath(fullpath || "");
		} else {
			lastLocation[root] = root + "/" + (context || "docs");
		}
		return { ...state, lastLocation };
	}
	render() {
		// namespace: "public" | "private"
		// root: "archive" | "trash" | undefined (undefined = docs tab)
		// fullpath: encoded subfolder path (only present on docs tab)
		const { namespace, root, fullpath } = this.props.match.params;
		const isDocTab = !root;
		const activeTab = root === "archive" ? 1 : root === "trash" ? 2 : 0;

		return (
			<div className="fullHeightFlex noDefaultMargin">
				<MaterialTabs
					activeTab={activeTab}
					tabs={tabMap}
					switchedTab={this.switchedTab}
				/>
				{this.props.documentListDataColumnsAreAbbreviated ? (
					<AbbreviatedDocumentListDataMessage />
				) : null}
				{isDocTab ? (
					<DocumentListWithRouter
						style={{ flex: 1 }}
						urlPrefix={this.getUrlPrefix()}
						matterID={0}
						breadcrumbRootName={basepathnameMap[namespace]}
						root={namespace + "/"}
						apiBasepath={this.getAPIBasepath()}
						fullpath={fullpath}
						values={this.props.documentList}
					/>
				) : (
					<ArchiveAndTrashList root={root} />
				)}
			</div>
		);
	}
}
FirmDocs.propTypes = {
	loading: PropTypes.bool.isRequired,
};
const mapStateToProps = (state) => ({
	loading: state.document.loading,
	documentList: state.document.documentList,
	documentListDataColumnsAreAbbreviated:
		state.document.documentListDataColumnsAreAbbreviated,
});
export default connect(mapStateToProps, {
	listDirectory,
	unselectAll,
	setCreatableContext,
	setSubheaderText,
})(FirmDocs);
